import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const trendMicro = defineConnector({
  identifier: "trendMicro",
  name: "Trend Micro",
  tagLine: "Cybersecurity platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    baseUrl
      ? `https://${baseUrl.replace(/\./g, "\\.")}/.*`
      : "https://api\\.xdr\\.trendmicro\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Trend Micro Vision One, go to **Administration → API Keys** and create a new key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API base URL",
          required: true,
          placeholder: "api.xdr.trendmicro.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText:
            "Your regional API hostname (e.g., `api.xdr.trendmicro.com` for US, `api.eu.xdr.trendmicro.com` for EU).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) =>
      `https://${baseUrl || "api.xdr.trendmicro.com"}/v3.0/healthcheck/connectivity`,
  },
});
